module.exports = __webpack_public_path__ + "img/pattern_2.b45f83bc.png";